export default __webpack_public_path__ + "static/differential-scroll-02-820a6aef99e926e2831d48ed486753bb.jpg";